import React from 'react'
import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://dhgc.org.in'

const StructuredData = () => {
  const baseUrl = SITE_URL
  
  const schoolData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Dr. Haribhai Godhani Campus",
    "alternateName": ["DHGC", "Shree Sardar Patel Education Trust Campus", "DHGC Junagadh"],
    "url": baseUrl,
    "logo": `${baseUrl}/logo.jpg`,
    "image": [`${baseUrl}/logo.jpg`, `${baseUrl}/about/sardar-patel.jpg`],
    "description": "Dr. Haribhai Godhani Campus, managed by Shree Sardar Patel Education Trust, is a comprehensive educational institution providing quality education from K.G. to Postgraduate level (B.Sc, B.B.A, B.Com, B.C.A, B.A, B.Ed, Law, M.Com, M.A) with 55+ years of educational excellence since 1965.",
    "foundingDate": "1965",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "B/H. Railway Station, Sardarpara, Joshipura",
      "addressLocality": "Junagadh",
      "addressRegion": "Gujarat",
      "postalCode": "362001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "21.52",
      "longitude": "70.45"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-9427805272",
        "contactType": "Admissions",
        "areaServed": "IN-GJ",
        "availableLanguage": ["English", "Gujarati"],
        "email": "info@sardarpateleducationtrust.org"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+91-9427805272",
        "contactType": "Customer Service",
        "areaServed": "IN-GJ",
        "availableLanguage": ["English", "Gujarati"],
        "email": "dr.haribhaigodhanicampusjnd@gmail.com"
      }
    ],
    "sameAs": [
      baseUrl
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Academic Programs",
      "board": "Gujarat University / Various University Affiliations",
      "itemListElement": [
        {
          "@type": "Course",
          "name": "School Education (K.G. to 12th)",
          "description": "Comprehensive school education from kindergarten to higher secondary with streams in Science, Commerce, and Arts in both Gujarati and English medium",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Dr. Haribhai Godhani Campus"
          },
          "educationalLevel": "K.G. to Higher Secondary",
          "inLanguage": ["en", "gu"]
        },
        {
          "@type": "Course", 
          "name": "Graduation Program",
          "description": "Bachelor's degree programs including B.Sc, B.B.A, B.Com, B.C.A, B.A, P.T.C, B.Ed, and LL.B with comprehensive curriculum and practical training",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Dr. Haribhai Godhani Campus"
          },
          "educationalLevel": "Undergraduate",
          "inLanguage": ["en", "gu"]
        },
        {
          "@type": "Course",
          "name": "Postgraduation Program",
          "description": "Master's degree programs including M.Com and M.A with specializations and research opportunities",
          "provider": {
            "@type": "EducationalOrganization",
            "name": "Dr. Haribhai Godhani Campus"
          },
          "educationalLevel": "Postgraduate",
          "inLanguage": ["en", "gu"]
        }
      ]
    },
    "alumni": {
      "@type": "AlumniAssociation",
      "name": "Dr. Haribhai Godhani Campus Alumni Network",
      "description": "Active alumni network with successful professionals across various fields worldwide, spanning over 55 years"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": "21.52",
        "longitude": "70.45"
      },
      "geoRadius": "50000"
    }
  }

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": baseUrl
      }
    ]
  }

  // FAQ Schema for common questions
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Where is Dr. Haribhai Godhani Campus located?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Dr. Haribhai Godhani Campus is located at B/H. Railway Station, Sardarpara, Joshipura, Junagadh - 362001, Gujarat, India. It is managed by Shree Sardar Patel Education Trust."
        }
      },
      {
        "@type": "Question",
        "name": "What programs does the campus offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The campus offers comprehensive education from K.G. to Postgraduate level including school education (K.G. to 12th), Graduation Program (B.Sc, B.B.A, B.Com, B.C.A, B.A, P.T.C, B.Ed, LL.B), and Postgraduation Program (M.Com, M.A) in both English and Gujarati mediums."
        }
      },
      {
        "@type": "Question",
        "name": "How can I contact the campus for admissions?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can contact us at +91-9427805272 or email us at info@sardarpateleducationtrust.org or dr.haribhaigodhanicampusjnd@gmail.com for admission inquiries. Our office is open Monday to Saturday from 9:00 AM to 5:00 PM."
        }
      },
      {
        "@type": "Question",
        "name": "Who manages Dr. Haribhai Godhani Campus?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The campus is managed by Shree Sardar Patel Education Trust and Joint Trusts, with a legacy of providing quality education since 1965. The trust was founded by Late Dr. Haribhai Godhani and is currently led by Chairman Shree J.K. Thesia."
        }
      },
      {
        "@type": "Question",
        "name": "What facilities are available on campus?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The campus offers hostel facilities, science laboratories, library, smart classrooms, computer labs, sports activities, and transportation services for students."
        }
      }
    ]
  }

  // WebSite Schema for search box
  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Dr. Haribhai Godhani Campus",
    "alternateName": "DHGC - DHGC Junagadh",
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/?s={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schoolData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
    </Helmet>
  )
}

export default StructuredData
